import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const fetchgetInvitedUserDetailsById = createAsyncThunk('getUserById/fetchUserById',
  async (id, { rejectWithValue }) => {
    try {
      const url = `${api.getInvitedUserDetailsById}${id}`;
      const response = await axiosPrivate.get(url, {
        headers: {
          'custom-auth-type': 'token'
        }
      })
      if (response.data.success === true) {
        return response.data.data;

      }
      else {
        toast.error(`${response.data.reason}`, {
          className: "toast-error-custom",
        });
        localStorage.removeItem("token");
        localStorage.clear();
        globalThis.location.replace("/email-verification", { replace: true });


      }
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server")
    }
  })

const getInvitedUserDetailsSlice = createSlice({
  name: 'getInvitedUserDetailsById',
  initialState: {
    getInvitedUserDetailsById: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders.
      addCase(fetchgetInvitedUserDetailsById.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchgetInvitedUserDetailsById.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.getInvitedUserDetailsById = action.payload;
        })
      .addCase(fetchgetInvitedUserDetailsById.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        });
  }
})

export default getInvitedUserDetailsSlice.reducer;